export default __webpack_public_path__ + "static/media/IMG-20240822-WA0001.8e093c6a.jpg";